import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseWiseStock } from "./thunk";

interface DistrictState {
  WarehouseWiseStockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  WarehouseWiseStockList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "WarehouseWiseStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseWiseStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseWiseStock.fulfilled, (state, action) => {
        state.loading = false;
        const dataArray = Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
          ? action.payload
          : [];
        state.WarehouseWiseStockList = dataArray;
        state.rowCount =
          typeof action.payload?.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchWarehouseWiseStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch inventoryList";
      });
  },
});

export default inventorySlice.reducer;
